import React, { useState } from 'react';
import { Search, Sparkles, BookOpen, Brain, Zap, Star, Trophy } from 'lucide-react';
import './SearchBar.css';

const SearchBar = ({ onSearch, loading, stats = { streak: 0, gems: 0, hearts: 5 } }) => {
  const [concept, setConcept] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (concept.trim()) {
      onSearch(concept.trim());
    }
  };

  const handleInputChange = (e) => {
    setConcept(e.target.value);
    setIsTyping(e.target.value.length > 0);
  };



  return (
    <div className="card duo-lesson-card searchbar-container">
      {/* Duolingo-style floating mascot elements */}
      <div className="duo-float float-brain" aria-hidden="true">
        <Brain size={28} color="white" />
      </div>
      
      <div className="duo-float float-book" aria-hidden="true">
        <BookOpen size={20} color="white" />
      </div>

      <div className="duo-float float-star" aria-hidden="true">
        <Star size={16} color="white" />
      </div>

      <div className="header-container">
        <div className="title-container">
          <div className="duo-mascot" aria-hidden="true">
            <Sparkles size={36} color="#58cc02" />
          </div>
          <h1 className="title-text">
            DuoLearn
          </h1>
          <div className="duo-mascot" style={{ animationDelay: '1s' }} aria-hidden="true">
            <Trophy size={36} color="#ff9500" />
          </div>
        </div>
        
        <p className="subtitle">
          Master any concept with 
          <span className="highlight-text"> AI-powered </span>
          lessons, flashcards, and quizzes! 🎯
        </p>
        
        {/* Duolingo-style stats bar */}
        <div className="stats-container" aria-label="User Stats">
          <div className="duo-streak" aria-label={`${stats.streak} Day Streak`}>
            <span aria-hidden="true">🔥</span> {stats.streak} Day Streak
          </div>
          <div className="duo-gem" aria-label={`${stats.gems} Gems`}>
            <span aria-hidden="true">💎</span> {stats.gems} Gems
          </div>
          <div className="duo-heart" aria-label={`${stats.hearts} Hearts`}>
            <span aria-hidden="true">❤️</span> {stats.hearts} Hearts
          </div>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="search-form" role="search">
        <div className="search-input-wrapper">
          <div className={`input-container ${isTyping ? 'typing' : ''}`}>
            <Search 
              size={24} 
              className={`search-icon ${isTyping ? 'typing' : 'default'}`}
              aria-hidden="true"
            />
            <input
              type="text"
              value={concept}
              onChange={handleInputChange}
              placeholder="What would you like to learn today? 🤔"
              className="input search-input"
              disabled={loading}
              aria-label="Search for a concept to learn"
            />
          </div>
          <button 
            type="submit" 
            className="btn submit-btn"
            disabled={loading || !concept.trim()}
            aria-label={loading ? "Generating lesson" : "Start Learning"}
            aria-live="polite"
          >
            {loading ? (
              <>
                <div className="spinner btn-spinner" aria-hidden="true" />
                Learning...
              </>
            ) : (
              <>
                <Zap size={22} aria-hidden="true" />
                Start Learning!
              </>
            )}
          </button>
        </div>
      </form>


    </div>
  );
};

export default SearchBar;